.dashboardLayoutFrame {
  display: flex;
  flex-flow: column nowrap;

  margin: 12px 0 20px;
}

.topBar {
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;

  padding: 1px 16px;
}

.left,
.right {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
}

.left {
  justify-content: flex-start;
}

.right {
  justify-content: flex-end;
}
